import React from 'react';
import { useTheme } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Avatar from '@material-ui/core/Avatar';

const items = [
  {
    icon: (
      <svg width={28} height={28} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" />
      </svg>
    ),
    title: 'Rotativa Tips Canguro',
    description:
      'Micros de 30–45 s en Radio Visual 24/7. Bronce: 4/día · Plata y Oro: impacto diario en grilla (Tips Canguro).',
    price: 60,
    note: 'Desde 60 €/mes en plan Bronce',
  },
  {
    icon: (
      <svg width={28} height={28} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
      </svg>
    ),
    title: 'TNO Digest (SEO)',
    description:
      'Artículos en tnonetwork.com: B2B, retail tech, accesorios y decisiones de compra. Bronce 2/mes · Plata 8/mes · Oro hasta 16/mes.',
    price: 45,
    note: 'Calendario editorial según plan',
  },
  {
    icon: (
      <svg width={28} height={28} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
      </svg>
    ),
    title: 'Programas selectivos',
    description:
      'TNO Business, Franquicias en Venezuela y Noticias TNO. Bronce: 1 mención/mes · Plata: presencia en los 3 · Oro: bloques dedicados.',
    price: 38,
    note: 'Integración orgánica en antena',
  },
  {
    icon: (
      <svg width={28} height={28} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z" />
      </svg>
    ),
    title: 'Inserts en señal',
    description:
      'Lower thirds en vivo con CTA y QR dinámico hacia guías web. Frecuencia y creatividades escalan de Bronce a Oro.',
    price: 30,
    note: 'Sin interrumpir la programación',
  },
  {
    icon: (
      <svg width={28} height={28} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
      </svg>
    ),
    title: 'Redes (TNO × Canguro)',
    description:
      'Clips y co-publicaciones en Instagram y TikTok. Bronce 4 · Plata paquete estándar · Oro 12+ piezas y carruseles.',
    price: 23,
    note: 'Co-acreditación de marca',
  },
  {
    icon: (
      <svg width={28} height={28} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
      </svg>
    ),
    title: 'Producción TNO',
    description:
      'Conceptualización, edición, locución, postproducción y redacción SEO. Canguro aporta manual de marca y activos vectorizados.',
    price: 23,
    note: 'Incluida según alcance del plan',
  },
];

const ContenidoParaMarcas = () => {
  const theme = useTheme();

  return (
    <Box>
      <Box marginBottom={4}>
        <Typography
          sx={{ textTransform: 'uppercase', fontWeight: 600 }}
          gutterBottom
          color="primary"
          align="center"
        >
          Inventario de comercialización
        </Typography>
        <Typography variant="h4" fontWeight={700} align="center" gutterBottom>
          Señal, programas, Digest y redes
        </Typography>
        <Typography variant="h6" component="p" color="textSecondary" align="center" sx={{ maxWidth: 680, mx: 'auto' }}>
          Cada pieza del mix cumple una función en el recorrido inbound: recordar en rotativa, profundizar en
          programas, captar búsquedas en Google y amplificar en redes. El detalle de calendario editorial y
          condiciones operativas se define al activar el plan con el equipo comercial TNO.
        </Typography>
      </Box>
      <Grid container spacing={3}>
        {items.map((item, i) => (
          <Grid item xs={12} sm={6} md={4} key={i} data-aos="fade-up">
            <Box
              component={Card}
              height="100%"
              variant="outlined"
              sx={{
                transition: 'all .2s ease-in-out',
                '&:hover': { boxShadow: 4, borderColor: theme.palette.primary.main },
              }}
            >
              <CardContent>
                <Box
                  component={Avatar}
                  variant="rounded"
                  sx={{
                    width: 56,
                    height: 56,
                    mb: 2,
                    bgcolor: `${theme.palette.primary.main}33`,
                    color: theme.palette.secondary.main,
                  }}
                >
                  {item.icon}
                </Box>
                <Typography variant="h6" fontWeight={700} gutterBottom color="primary">
                  {item.title}
                </Typography>
                <Typography variant="body2" color="textSecondary" sx={{ mb: 1 }}>
                  {item.description}
                </Typography>
                <Typography variant="h6" fontWeight={700} color="primary">
                  desde {item.price} €
                </Typography>
                <Typography variant="caption" color="textSecondary" display="block" sx={{ mt: 0.5 }}>
                  {item.note}
                </Typography>
              </CardContent>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default ContenidoParaMarcas;
